/* ═══════════════════════════════════════════════════════════════
 * SESSIONS — verticale markeringen bij de open van elke handelssessie
 * (Asia / London / New York, in UTC). 1:1 poort van TERMINAL.sessions
 * uit terminal_wyckoffpcg.html. Tijd→x via timeToCoordinate op de
 * dichtstbijzijnde candle. Overlay-canvas, redraw bij pan/zoom.
 * ═══════════════════════════════════════════════════════════════ */

// UTC-openingsuren + kleuren
const SESSIONS = [
  { name: "ASIA", hour: 0, col: "108,92,231" },
  { name: "LON", hour: 8, col: "240,185,11" },
  { name: "NY", hour: 13, col: "38,161,123" },
];

// container: het DOM-element waar de chart in hangt
// getApi: () => { chart, candleSeries }
// getCandles: () => huidige candle-array
export function createSessions(container, getApi, getCandles) {
  const canvas = document.createElement("canvas");
  canvas.className = "ss-overlay";
  Object.assign(canvas.style, { position: "absolute", inset: "0", pointerEvents: "none", zIndex: "2" });
  container.style.position = "relative";
  container.appendChild(canvas);
  const ctx = canvas.getContext("2d");

  let visible = true, rafPending = false;

  function sizeCanvas() {
    const dpr = window.devicePixelRatio || 1;
    const w = container.clientWidth, h = container.clientHeight;
    canvas.width = Math.round(w * dpr); canvas.height = Math.round(h * dpr);
    canvas.style.width = w + "px"; canvas.style.height = h + "px";
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }

  // Binaire zoek naar dichtstbijzijnde candle-tijd
  function nearestCandleTime(candles, t) {
    let lo = 0, hi = candles.length - 1;
    if (t <= candles[lo].time) return candles[lo].time;
    if (t >= candles[hi].time) return candles[hi].time;
    while (lo <= hi) {
      const mid = (lo + hi) >> 1;
      if (candles[mid].time < t) lo = mid + 1; else hi = mid - 1;
    }
    return candles[lo].time;
  }

  function draw() {
    rafPending = false;
    sizeCanvas();
    const w = container.clientWidth, h = container.clientHeight;
    ctx.clearRect(0, 0, w, h);
    if (!visible) return;

    const candles = getCandles();
    if (!candles || candles.length < 2) return;
    const { chart } = getApi();
    const ts = chart.timeScale();

    const t0 = candles[0].time, t1 = candles[candles.length - 1].time;
    const dayStart = Math.floor(t0 / 86400) * 86400;

    ctx.font = "700 8px 'JetBrains Mono',monospace";
    for (let day = dayStart; day <= t1 + 86400; day += 86400) {
      for (const s of SESSIONS) {
        const open = day + s.hour * 3600;
        if (open < t0 || open > t1) continue;
        const ct = nearestCandleTime(candles, open);
        const x = ts.timeToCoordinate(ct);
        if (x == null) continue;

        ctx.strokeStyle = `rgba(${s.col},0.28)`;
        ctx.lineWidth = 1;
        ctx.setLineDash([3, 4]);
        ctx.beginPath(); ctx.moveTo(x, 0); ctx.lineTo(x, h - 22); ctx.stroke();
        ctx.setLineDash([]);

        ctx.fillStyle = `rgba(${s.col},0.9)`;
        ctx.fillText(s.name, x + 3, h - 26);
      }
    }
  }

  function scheduleRedraw() { if (rafPending) return; rafPending = true; requestAnimationFrame(draw); }

  function destroy() {
    try { canvas.remove(); } catch {}
  }

  return {
    redraw: scheduleRedraw,
    setVisible: (v) => { visible = v; scheduleRedraw(); },
    destroy,
  };
}
